

















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { TextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import TextBoxWrapperObject from "../../../document/editor/objects/TextBoxWrapperObject.vue";
import TextBoxInputMethodSelector from "../inputMethodEditors/TextBoxInputMethodSelector.vue";
import ClipboardMenu from "./ClipboardMenu.vue";
import ObjectMenuButton from "./ObjectMenuButton.vue";
import HisInformationFixedPhrasesMenu from "./HisInformationFixedPhrasesMenu.vue";

@Component({
  components: {
    ClipboardMenu,
    TextBoxInputMethodSelector,
    ObjectMenuButton,
    HisInformationFixedPhrasesMenu,
  }
})
export default class TextObjectMenu extends Mixins() {
  @Prop()
  source: TextBoxWrapperObject;

  @Prop()
  isInputMethodSelectable: boolean;

  get selected(): TextBoxInputMethodKinds {
    return this.source.inputMethodKind;
  }

  set selected(value: TextBoxInputMethodKinds) {
    this.source.emitFocus();
    this.$nextTick(() => {
      this.source.inputMethodKind = value;
      this.source.setFocus();
    });
  }

  getButtonClass(kind: TextBoxInputMethodKinds): string {
    return Enumerable.from(this.buttonClasses)
      .first(c => c.key === kind)
      .class;
  }

  isVisible(kind: TextBoxInputMethodKinds): boolean {
    return !!this.getButtonClass(kind);
  }

  buttonClasses: { key: TextBoxInputMethodKinds, class: string }[] = [
    { key: TextBoxInputMethodKinds.None, class: "text-object-menu-none" },
    { key: TextBoxInputMethodKinds.FreeInput, class: "text-object-menu-free" },
    { key: TextBoxInputMethodKinds.HisInfoSelect, class: "text-object-menu-data" },
    { key: TextBoxInputMethodKinds.UserDefinitionSelect, class: "text-object-menu-data" },
    { key: TextBoxInputMethodKinds.MKSTemplate, class: "text-object-menu-data" }, // TODO:アイコン差し替え.
    { key: TextBoxInputMethodKinds.DynamicTemplate, class: "text-object-menu-data" }, // TODO:アイコン差し替え.
  ];
}
